import MuiDrawer from "@mui/material/Drawer";
const Drawer = MuiDrawer;
export default Drawer;
